import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../../../Components/consts'
import { Head3, DescSm } from '../../../../../../Components/Typography/Text.styles'

export const CoreStatsRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'stretch',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  margin: theme.spacing(2, 0, 8, 0),
  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
    margin: theme.spacing(3, 0, 6, 0),
  },
}))

export const StyledStatCard = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: 16,
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${colors.gray.gray20}`,
  minWidth: 180,
  [theme.breakpoints.down('md')]: {
    minWidth: 90,
    padding: 8,
  },
}))

export const StatInfoContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
})

export const StatName = styled(DescSm)({
  color: colors.helperText,
  fontWeight: 500,
  margin: 0,
})

export const StatValue = styled(Head3)(({ theme }) => ({
  margin: 0,
  lineHeight: 1.2,
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.medium,
  },
}))

export const ComplementaryInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
  '& .val': {
    margin: '0 1px',
    fontWeight: 700,
    color: colors.text,
    fontSize: fontSizes.small,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.xSmall,
    },
  },
  '& .label': {
    margin: '0 1px',
    color: colors.helperText,
    fontSize: fontSizes.small,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.xSmall,
    },
  },
}))

export const IconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: colors.gray.gray20,
  marginLeft: 16,
  flexShrink: 0,
})
